import { render } from "./steps.vue?vue&type=template&id=ff1b7c48&scoped=true"
import script from "./steps.vue?vue&type=script&lang=js"
export * from "./steps.vue?vue&type=script&lang=js"

import "./steps.vue?vue&type=style&index=0&id=ff1b7c48&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1b7c48"]])

export default __exports__